<template>
    <b-row>
        <b-col class="mt-2 mb-2 ml-3 mr-3" v-if="totalDocuments > 0">
            <!-- titre main graph -->
            <b-row>
                <b-col cols="6">
                    <span class="OTLandingTitleS3">Document by Type</span>
                </b-col>
                <b-col cols="6" class="text-right">
                    <span class="OTLandingTitleS3">Document Total: {{ totalDocuments }}</span>
                </b-col>
            </b-row>

            <b-row class="OTgraphMain">
                <b-col cols="8" class="OTgraphMainGraphLeft">
                    <!-- WEB -->
                    <lineMainGraph
                    	v-if="crawledWeb > 0"
                        :LineClassName="'web'"
                        :LineLabel="'Web'"
                        :LinetotalDoc="crawledWeb"
                        :LineWidth="'width:'+ Number(((crawledWeb*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                    <!-- Twitter -->
                    <lineMainGraph
                    	v-if="crawledTwitter > 0"
                        :LineClassName="'twitter'"
                        :LineLabel="'Twitter'"
                        :LinetotalDoc="crawledTwitter"
                        :LineWidth="'width:'+ Number(((crawledTwitter*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                    <!-- ECM -->
                    <lineMainGraph
                    	v-if="crawledECM > 0"
                        :LineClassName="'ecm'"
                        :LineLabel="'ECM'"
                        :LinetotalDoc="crawledECM"
                        :LineWidth="'width:'+ Number(((crawledECM*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                    <!-- ECM ANNOTATOR-->
                    <lineMainGraph
                    	v-if="crawledAnnotated > 0"
                        :LineClassName="'annotator'"
                        :LineLabel="'ECM Annotator'"
                        :LinetotalDoc="crawledAnnotated"
                        :LineWidth="'width:'+ Number(((crawledAnnotated*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                    <!-- RDBMS -->
                    <lineMainGraph
                    	v-if="crawledRDBMSECM > 0"
                        :LineClassName="'rdbms'"
                        :LineLabel="'RDBMS'"
                        :LinetotalDoc="crawledRDBMSECM"
                        :LineWidth="'width:'+ Number(((crawledRDBMSECM*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                    <!-- LOCAL DOCUMENTS -->
                    <lineMainGraph
                    	v-if="crawledLocalDocuments > 0"
                        :LineClassName="'localDocuments'"
                        :LineLabel="'Local Documents'"
                        :LinetotalDoc="crawledLocalDocuments"
                        :LineWidth="'width:'+ Number(((crawledLocalDocuments*100)/totalDocuments).toFixed(1))  + '%' "
                    ></lineMainGraph>
                </b-col>

                <b-col cols="4" class="OTgraphMainGraphRight">
                    <b-row>
                        <!-- align-v="center" class="h-100"-->
                        <b-col cols="12" class="OTGlobalData OTGlobalDataPersisted">
                            <span class="OTGlobalDataLabel">Persisted</span>
                            <span class="OTGlobalDataValue">{{persistedDocuments}}</span>
                        </b-col>
                        <b-col cols="12" class="OTGlobalData OTGlobalDataEnriched">
                            <span class="OTGlobalDataLabel">Enriched</span>
                            <span class="OTGlobalDataValue">{{enrichedDocuments}}</span>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <b-col v-else class="mt-2 mb-2 ml-3 mr-3 OTnoObjectRunning">
            <b-alert class="OTAlert OTAlertInformation OTAlertLanding OTAlertLandingNoCrawl" show>
                <span class="ot-icon-alert-title"></span>
                No document crawled yet.
            </b-alert>
        </b-col>
    </b-row>
</template>

<script>
import Jobs from "@/collections/jobs.js";

import lineMainGraph from "./graphLine.vue";





export default {
    components: { lineMainGraph },
    data() {
        return {
            showDashboardPanel: true,
        } 
    }, 

    computed: {

      enrichedDocuments() {
            return this.$store.state.components.totals.enrichedDocuments|| 0;
        },
        persistedDocuments() {
            return this.$store.state.components.totals.persistedDocuments || 0;
        },
         crawledECM() {
           return this.$store.state.components.totals.crawledECM || 0;
        },
        crawledWeb() {
           return this.$store.state.components.totals.crawledWeb || 0;
        },
        crawledTwitter() {
            return this.$store.state.components.totals.crawledTwitter || 0;
        },
        crawledAnnotated() {
            return this.$store.state.components.totals.crawledAnnotated || 0;
        },
        crawledRDBMSECM() {
            return this.$store.state.components.totals.crawledRDBMSECM || 0;
        },
        crawledLocalDocuments() {
            return this.$store.state.components.totals.crawledLocalDocuments || 0;
        },
        totalDocuments() {
           return this.$store.state.components.totals.crawledLocalDocuments + this.$store.state.components.totals.crawledRDBMSECM + this.$store.state.components.totals.crawledAnnotated + this.$store.state.components.totals.crawledECM + this.$store.state.components.totals.crawledWeb + this.$store.state.components.totals.crawledTwitter;
        },
        username() {
            return this.$session.currentUser;
        },


        connecting() {
            return this.$store.state.socket.connecting;
        },

        connected() {
            return this.$store.state.socket.connected;
        },

        reconnecting() {
            return this.$store.state.socket.reconnecting;
        }
    },
     mounted() {
        if (this.connected) {
            this.$socket.sendObj({
                subscribe: ['totals']
            });
            this.$socket.sendObj({
                'filter': {
                    'queryPointId': "totals",
                    'facet':{
                        type  : 'condition',
                        field : 'TF_ID',
                        in    : ['LWD_ID']
                    }
                }
            });
        } else {
            this.$socket.connect();
        }
    },
    watch: {
        connected(newValue) {
            if (newValue === true) {
                this.$socket.sendObj({
                    subscribe: ['totals']
                });
                this.$socket.sendObj({
                'filter': {
                    'queryPointId': "totals",
                    'facet':{
                        type  : 'condition',
                        field : 'TF_ID',
                        in    : ['LWD_ID']
                        }
                    }
                });
            }
        }
    },
}
</script>

